import { ChangeDetectionStrategy, Component, Inject, TemplateRef } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SiModalModule } from '../../si-modal';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';

@Component({
  templateUrl: './message-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
		CommonModule,
    SiModalModule,
    MatButtonModule,
  ],
})
export class MessageDialogComponent {
	submitBtnText: string = 'Proceed';
	showCancelBtn: boolean = true;
  constructor(@Inject(MAT_DIALOG_DATA) readonly data: { message?: string, submitBtnText?: string, showCancelBtn?: boolean, messageTemplate?: TemplateRef<void> }) {
    this.submitBtnText = this.data.submitBtnText || 'Proceed';
    this.showCancelBtn = this.data.showCancelBtn !== undefined ? this.data.showCancelBtn : true;
  }
}